import PostTitleList from './PostTitleList';

export default PostTitleList;
